export default __webpack_public_path__ + "static/media/HalfMoon.1297533b.jpg";